import { RiskBadge } from "./RiskBadge";
import { ArrowUpRight, Users, Repeat } from "lucide-react";

const TYPE_LABEL = {
  OWNER_DEPENDENCY: "Dependencia del propietario",
  KEY_PERSON_DEPENDENCY: "Persona clave",
  KNOWLEDGE_DEPENDENCY: "Conocimiento",
  DECISION_DEPENDENCY: "Decisión",
  PROCESS_DEPENDENCY: "Proceso",
  BACKUP_GAP: "Sin backup",
  ESCALATION_DEPENDENCY: "Escalado",
};

const SOL_LABEL = {
  DELEGATE: "Delegar", DOCUMENT: "Documentar", TRAIN: "Formar",
  AUTOMATE: "Automatizar", ELIMINATE: "Eliminar", REDESIGN: "Rediseñar",
};

export function DependencyCard({ dep, index = 0, onClick, onBuild, testId }) {
  return (
    <div
      className="card-arch p-5 cursor-pointer group"
      data-testid={testId || `dependency-card-item-${index}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <span className="mono-label text-cyan-400/80">{TYPE_LABEL[dep.type] || dep.type}</span>
          <h4 className="mt-1.5 font-head text-base font-semibold text-white leading-snug">{dep.title}</h4>
        </div>
        <RiskBadge severity={dep.severity} showPulsingDot={dep.severity === "CRITICAL"} />
      </div>
      {dep.description && <p className="mt-2.5 text-sm text-slate-400 line-clamp-2">{dep.description}</p>}

      <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-slate-500">
        {dep.affected_people?.length > 0 && (
          <span className="inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" />{dep.affected_people.join(", ")}</span>
        )}
        {dep.frequency && <span className="inline-flex items-center gap-1"><Repeat className="h-3.5 w-3.5" />{dep.frequency}</span>}
        {dep.backup_exists === false && <span className="text-red-400/80">Sin backup validado</span>}
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-white/5 pt-3">
        <span className="text-xs font-medium text-amber-400">
          Solución: {SOL_LABEL[dep.recommended_solution] || dep.recommended_solution || "—"}
        </span>
        {onBuild && (
          <button
            data-testid={`dependency-build-btn-${index}`}
            onClick={(e) => { e.stopPropagation(); onBuild(dep); }}
            className="inline-flex items-center gap-1 text-xs font-semibold text-white hover:text-amber-400 transition-colors"
          >
            Delegar con Architect <ArrowUpRight className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}
